import * as API from "middleware/api";

export const loadListRequest = (filters) => API.executeWithAccessToken("list.discount.echeq", { ...filters });
export const validateThirdPayment = (params) => API.executeWithAccessToken("/transfers.third.parties", { ...params });

export const loadListEcheqLotRequest = ({ filters, ...data }) =>
    API.executeWithAccessToken("list.echeq.lot", { ...data, ...filters });

export const loadListEcheqRequest = (params) => API.executeWithAccessToken("list.process.echeq.discounts", params);
export const loadDiscountSimulationRequest = (params) => API.executeWithAccessToken("simulate.echeq.discounts", params);

export const getPartialEcheqs = (params) => API.executeWithAccessToken("negotiate.partial.echeq.discounts", params);

// export const loadListRequest = (filters) => API.executeWithAccessToken("read.batch.transfers", { ...filters });

export const downloadTransactionLinestMiddleware = (format, transactionLines) =>
    API.executeWithAccessToken("/transactionLines.download", { format, transactionLines });

export const downloadListRequestMiddleware = (format, transactionLinesStatus) =>
    API.executeWithAccessToken("/listThirdPayment.download", { format, transactionLinesStatus });

export const downloadDetailEcheqDiscountMiddleware = (idTransactionLot, echeqNumber, idBatch) =>
    API.executeWithAccessToken("/download.discounted.echeq.detail", {
        idTransactionLot,
        echeqNumber,
        idBatch,
    });

export const downloadDetailEcheqBatchMiddleware = (params) =>
    API.executeWithAccessToken("/download.echeq.batch.detail", params);

export const downloadConfirmation = (summary) =>
    API.executeWithAccessToken("/thirdPayment.downloadConfirm", { summary });

export const downloadDocumentMiddleware = (fileId) => API.executeWithAccessToken("/files.download", { idFile: fileId });

export const listCredentialsGroups = (params) =>
    API.executeWithAccessToken("/core.listTransactionCredentialsGroups", params);

export const listCredentialsGroupsMock = () => ({
    status: 200,
    data: {
        code: "COR000I",
        idTransaction: "dfd5cbf761b54db8a351967a760dac8e",
        message: "Operación ejecutada con éxito",
        data: {
            groups: [
                {
                    idCredentialGroup: "accessToken-otp",
                    credentials: ["accessToken", "password"],
                },
            ],
        },
    },
});

export const openLotOtherEcheq = (params) => API.executeWithAccessToken("/load.echeq.discounts", params);

export const openLotOwnEcheq = (params) => API.executeWithAccessToken("/openLot.ownEcheq.send", params);

export const discountRequestMockSuccess = () => ({
    status: 200,
    data: {
        code: "COR000I",
        idTransaction: "4544d2f3c7824592826edaf55b4e895f",
        message: "Operación ejecutada con éxito",
        data: {
            discount: {},
            idAccount: "2f3245006e9f76b5ce0c0dc39115c50fee39f869",
            number: "123189",
            cbu: "122131121873513831",
            alias: "2111331113CL001",
        },
    },
});

export const discountRequestMockPending = () => ({
    status: 200,
    data: {
        code: "COR023I",
        idTransaction: "832003e5bd70427cba02f54fdc1a00b5",
        message: "La transacción requiere firmas adicionales para ser enviada al banco",
        data: {},
    },
});

export const refreshSession = () => API.executeWithAccessToken("/session.refresh");

export const sendTransactionTicket = (params) => API.executeWithAccessToken("ticket.echeqdiscount.send", params);
